var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.272,
    height: 21.747,
    viewBox: "0 0 26.272 21.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3110",
    "data-name": "Groupe 3110",
    transform: "translate(1166.712 -4915.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unsorted",
    transform: "translate(0 -1.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1002",
    "data-name": "Trac\\xE9 1002",
    d: "M-1140.754,4924.212a6.772,6.772,0,0,0-3.631-.978,7.022,7.022,0,0,0-3.261.761,7.025,7.025,0,0,0-3.261-.761,6.772,6.772,0,0,0-3.631.978.682.682,0,0,0-.315.576v8.26a.686.686,0,0,0,.357.6.69.69,0,0,0,.7-.026,5.4,5.4,0,0,1,2.89-.76,5.4,5.4,0,0,1,2.891.76.685.685,0,0,0,.741,0,5.4,5.4,0,0,1,2.89-.76,5.4,5.4,0,0,1,2.89.76.681.681,0,0,0,.371.11.687.687,0,0,0,.327-.084.684.684,0,0,0,.357-.6v-8.26A.681.681,0,0,0-1140.754,4924.212Zm-1.055.969v6.765a7.689,7.689,0,0,0-5.152,0v-6.763A6.191,6.191,0,0,1-1141.809,4925.181Zm-6.522,0v6.763a7.293,7.293,0,0,0-2.576-.453,7.315,7.315,0,0,0-2.576.451v-6.765A6.191,6.191,0,0,1-1148.331,4925.185Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1003",
    "data-name": "Trac\\xE9 1003",
    d: "M-1161.755,4916.074l-4.758,4.757a.68.68,0,0,0,0,.961.678.678,0,0,0,.961,0l3.6-3.6V4935.3l-3.6-3.6a.68.68,0,0,0-.961,0,.68.68,0,0,0,0,.961l4.758,4.757a.678.678,0,0,0,.961,0l4.757-4.757a.677.677,0,0,0,.2-.48.678.678,0,0,0-.2-.481.68.68,0,0,0-.961,0l-3.6,3.6v-17.107l3.6,3.6a.678.678,0,0,0,.961,0,.674.674,0,0,0,.2-.48.678.678,0,0,0-.2-.481l-4.757-4.757A.68.68,0,0,0-1161.755,4916.074Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogManager);
export default __webpack_public_path__ + "static/media/catalog-manager.41ad99777cfc48ad8dc2d27980d99627.svg";
export { ForwardRef as ReactComponent };